<script>
import formDialogCreate from '@/components/iglobalwin/formDialog';
import formPanelCreate from '@/components/iglobalwin/form-warps/dialog-form-panel/dialog-form-panel.js';
import { validRequired, validRangeDate } from '@/common/elementValid.js';
import googleads from '@/backend/services/googleAds/googleAds.js'
import selectCustomer from './selectCustomer';

function getFormData (_obj, vm) {
  let { attributes } = vm
  let { templateList, manualReportFormData } = attributes
  let { templateId, time, serviceIdList } = manualReportFormData
  return {
    templateId: {
      label: '报告模板',
      formType: 'sky-select',
      value: templateId || '',
      props: {
        label: 'name',
        value: 'id'
      },
      options: templateList,
      customOption: true,
      // 暂时对接
      setOptionValue: (data) => {
        let { createName, type } = data
        return `${createName} | ${type === 1 ? "个人模板" : "系统模板"}`
      },
      rules: [validRequired('请选择报告模板')],
    },
    time: {
      label: '日期范围',
      formType: 'sky-date-picker',
      value: time || [],
      type: 'daterange',
      rangeSeparator: '至',
      startPlaceholder: '开始日期',
      endPlaceholder: '结束日期',
      rules: [
        {
          required: true,
          ...validRangeDate('请选择日期范围')
        }
      ]
    },
    serviceIdList: {
      label: '选择服务单',
      formType: selectCustomer,
      value: serviceIdList || [],
      controlButton: false,
      rules: [
        {
          required: true,
          trigger: "blur",
          validator: (_rule, _value, callback) => {
            if (callback.length > 0) {
              return undefined;
            }
            return '请选择服务单'
          },
        }
      ]
    },
  };
}

async function submit (data) {
  try {
    let { attributes } = this
    let { templateList } = attributes
    let dataCopy = _.cloneDeep(data)
    let { time, templateId, serviceIdList } = dataCopy
    let template = templateList.find(item => {
      return item.id === templateId
    })
    dataCopy.startDate = time[0]
    dataCopy.endDate = time[1]
    dataCopy.templateName = template.name
    dataCopy.serviceIdList = serviceIdList.map(item => {
      return item.serviceId
    })
    delete dataCopy.time
    await googleads.addManualReport(dataCopy)
    this.$message.success('创建成功');
    this.$emit('confirm', data);
  } catch (error) {
    this.$message.error('创建失败');
    this.formData.loading = false;
  }
}

function cancel (self) {
  let data = {}
  let { formData } = self
  let { fields } = formData
  Object.keys(fields).forEach(key => {
    data[key] = fields[key].value
  })
  self.$emit('cancel', data);
}

async function onShowLoad ({ manualReportFormData }) {
  let { data: templateList } = await googleads.templateChooseList()
  return {
    manualReportFormData,
    templateList
  }
}

const componentForm = formPanelCreate(
  {
    getFormData,
    submit,
    cancel,
  },
  {
    labelWidth: '100px',
    labelPosition: 'top'
  }
);

export default formDialogCreate({
  name: 'manualReportForm',
  onShowLoad,
  componentForm
});
</script>

<style scoped lang="scss">
</style>
